// src/components/chat/UploadProgress.jsx
import React from 'react';
import './UploadProgress.css';

const UploadProgress = ({ isUploading, progress }) => {
    if (!isUploading) return null;

    return (
        <div className="upload-overlay">
            <div className="upload-progress-overlay">
                <div className="upload-progress-container">
                    <div className="upload-spinner">
                        <i className="bi bi-hourglass-split"></i>
                    </div>
                    <div className="upload-progress-text">
                        Отправка файлов... {progress > 0 && `${progress}%`}
                    </div>
                    <div className="upload-progress-bar">
                        <div
                            className="upload-progress-fill"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadProgress;